import { Card, Center, Stack, Text, ThemeIcon, Title, Button, Group } from '@mantine/core';
import { IconLock, IconArrowLeft } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import type { PortalModuleId } from '../../lib/api.customer';

/**
 * Bereich ist für die Firma freigeschaltet, diese Person kommt aber nicht hinein —
 * persönlich abgeschaltet oder ohne das Recht, das der Bereich braucht.
 *
 * Anders als „Demnächst": hier gibt es einen Weg hinein, nur nicht von allein —
 * deshalb der konkrete Hinweis, wen der Nutzer fragen muss. Ein bloßes „Kein Zugriff"
 * lässt ihn ratlos zurück.
 */
export function NoAccessPage({ title, module }: { title: string; module?: PortalModuleId }) {
  return (
    <Center py={60}>
      <Card withBorder radius="md" p="xl" maw={520} w="100%">
        <Stack align="center" gap="md">
          <ThemeIcon size={56} radius="xl" variant="light" color="gray">
            <IconLock size={30} />
          </ThemeIcon>
          <Title order={3} ta="center">{title}</Title>
          <Text size="sm" c="dimmed" ta="center">
            Für diesen Bereich ist Ihr Zugang nicht freigeschaltet.
            {module === 'contracts' && ' Laufzeiten und Kündigungsfristen sehen nur ausdrücklich benannte Personen.'}
            {' '}Wenden Sie sich an den Portal-Administrator Ihres Unternehmens oder an Ihren
            FixByte-Ansprechpartner.
          </Text>
          <Group>
            <Button
              component={Link}
              to="/customer/dashboard"
              variant="light"
              color="orange"
              leftSection={<IconArrowLeft size={16} />}
            >
              Zur Startseite
            </Button>
          </Group>
        </Stack>
      </Card>
    </Center>
  );
}
